export class User {
  id: number;
  username: string;
  adate: Date;

  constructor() {
    this.id = 0;
    this.username = '';
    this.adate = new Date();
  }
}
